import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as excel from '@attain-apps/fe/web/main/lib/excel'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'

import { Api } from './api.service'
import associations from './associations'
import { ClipboardItem } from './clipboard-item'
import * as plugins from './plugins'
import type { TypeParams } from './types'

// NOTE: rule collection should be after faFunctionCategoryCollection and
// faFunctionSubcategoryCollection because of the association with
// FaFunctionCategorization etc. Same goes for glRecord collection
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams, typeof associations> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      associations,
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: rule => rule.id,
      name: ec.Name.Predefined.RateRule,
      plugins: {
        additionalFactories: [
          new excel.ec.Factory(),
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: context => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    this.plugins.editingPlugin.feature.actions.markForDeletion
                      .from('Table.Row.Icons.Trash.Clicked')
                      .dispatch({ id: context.entity.id })
                  },
                },
              ],
              onClick: () => {
                collection.plugins.editingPlugin.feature.actions.edit
                  .from(`Table.Row-${context.entity.id}.Clicked`)
                  .dispatch({ id: context.entity.id })
              },
            }),
            search: true,
            // TODO:
            // overrides: {
            //   entities: (_ec, defaultSelector) => ({
            //     selector: store.selectors.Selector.create(
            //       defaultSelector,
            //       this._glEc.plugins.selectionPlugin.feature.selectors.getFirstSelected(
            //         {
            //           target: gl.SLIDEOUT_TARGET,
            //         },
            //       ).asSelector,
            //       (rules, selectedGlRecord) =>
            //         selectedGlRecord
            //           ? rules.filter(rule =>
            //               selectedGlRecord.applicableRuleIds.includes(+rule.id),
            //             )
            //           : rules,
            //     ),
            //   }),
            // },

            // transformers: {
            //   attribute: transformers.table.ATTRIBUTE,
            //   row: ds.transformers.UI.nonNull(transformers.table.ROW, {
            //     warnOnly: true,
            //   }),
            // },
          })),
          new clipboard.Factory({
            clipboardService: ngCore.inject(clipboard.Service),
            pasteClassRef: ClipboardItem,
          }),
          new plugins.application.Factory(),
        ],
        editing: {
          newCreation: input => ents.extra.rate.gl.Rule.Input.generate(input),
        },
      },
    })
  }
}
